import React, { forwardRef } from 'react'
import classNames from 'classnames'

// evertel
import { Label } from '../index'


export type CheckboxChangeProps = {
    name?: string
    value?: string | number | readonly string[]
    checked: boolean
}
interface CheckboxProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> {
    id?: string
    name?: string
    value?: string | number | readonly string[]
    checked?: boolean
    onChange?: ({ name, value, checked }: CheckboxChangeProps) => void
    disabled?: boolean
    urgent?: boolean
    radio?: boolean
    label?: string
    className?: string
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>
}
const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({
    id,
    name,
    value,
    checked = false,
    onChange,
    disabled = false,
    urgent,
    radio = false,
    label,
    className,
    inputProps,
    ...otherProps
}, ref) => {
    const _inputClassName = classNames(
        {
            [`check-success`]: checked && !urgent,
            [`check-danger`]: checked && urgent,
            [`check-radio`]: radio
        },
        className
    )
    const input = (
        <span className="d-inline-block">
            <input
                {...(id && { id: id })}
                {...(name && { name: name })}
                className={_inputClassName}
                type="checkbox"
                value={value ?? ''}
                disabled={disabled}
                checked={checked}
                aria-checked={checked}
                onChange={() => onChange && onChange({ name, value, checked: !checked })}
                {...inputProps}
            />
        </span>
    )
    const content = label ? (
        <Label
            className="flex items-center cursor-pointer"
        >
            {input}
            <span className="ms-2">{label}</span>
        </Label>
    ) : ( input )

    return (
        <div
            ref={ref}
            className={classNames('form-checkbox', className)}
            {...otherProps}
        >
            {content}
        </div>
    )
})

export { Checkbox }
